/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DevRobotIcon16Light } from './DevRobotIcon16Light';
import { DevRobotIcon16Regular } from './DevRobotIcon16Regular';
import { DevRobotIcon16Solid } from './DevRobotIcon16Solid';
import { DevRobotIcon20Light } from './DevRobotIcon20Light';
import { DevRobotIcon20Regular } from './DevRobotIcon20Regular';
import { DevRobotIcon20Solid } from './DevRobotIcon20Solid';
import { DevRobotIcon24Regular } from './DevRobotIcon24Regular';
import { DevRobotIcon24Solid } from './DevRobotIcon24Solid';
import { DevRobotIcon32Regular } from './DevRobotIcon32Regular';
import { DevRobotIcon64Regular } from './DevRobotIcon64Regular';
var sizes = {
    16: {
        light: DevRobotIcon16Light,
        regular: DevRobotIcon16Regular,
        solid: DevRobotIcon16Solid,
    },
    20: {
        light: DevRobotIcon20Light,
        regular: DevRobotIcon20Regular,
        solid: DevRobotIcon20Solid,
    },
    24: {
        regular: DevRobotIcon24Regular,
        solid: DevRobotIcon24Solid,
    },
    32: {
        regular: DevRobotIcon32Regular,
    },
    64: {
        regular: DevRobotIcon64Regular,
    },
};
export var DevRobotIcon = forwardRef('DevRobotIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
